<template>
    <div style="padding: 10px">

        <!--    搜索区域-->
        <el-form :inline="true">
            <el-form-item label="手机号">
                <el-input v-model="search" placeholder="请输入手机号关键字" clearable> <template
                        #slot="prepend">Http://</template>
                </el-input>
            </el-form-item>
            <el-form-item label="房间类型">
                <el-select v-model="room" placeholder="请选择" style="width: 100%;" @change="getTime">
                    <el-option v-for="item in gameList" :key="item.code" :label="item.name" :value="item.code">
                        <span style="float: left">{{ item.name }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预订日期">         
                    <el-date-picker v-model="orderDate" type="date" placeholder="选择日期"
                        value-format="YYYY-MM-DD" format="YYYY-MM-DD" style="width: 100%;">
                    </el-date-picker>  
            </el-form-item>
            <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
            <el-button type="primary" @click="add">新增</el-button>
            <!-- <el-upload action="http://localhost:9090/order/import" :on-success="handleUploadSuccess"
                :show-file-list=false :limit="1" accept='.xlsx' style="display: inline-block; margin: 0 10px">
                <el-button type="primary">导入</el-button>
            </el-upload>
            <el-button type="primary" @click="exportorder">导出</el-button> -->
        </el-form>

        <el-table v-loading="loading" :data="tableData" border  style="width: 100%"    :row-class-name="getRowClassName">
            <el-table-column align="center" label="序号" type="index" width="90"></el-table-column>


            <el-table-column prop="name" label="称呼" align="center">
            </el-table-column>
            <el-table-column prop="telphone" label="手机号" align="center" width="120">
            </el-table-column>
            <el-table-column prop="orderDate" label="预订日期" align="center" width="100">
            </el-table-column>
            <el-table-column prop="statrTime" label="开始时间" width="100" align="center">
            </el-table-column>
            <el-table-column prop="endTime" label="结束时间" width="120" align="center">
            </el-table-column>
            <el-table-column prop="perpleNum" label="人数" align="center" width="80">
            </el-table-column>
            <el-table-column prop="bycar" label="是否开车" align="center" :formatter="formatterGame1">
            </el-table-column>
            <el-table-column prop="money" label="金额" align="center" width="80">
            </el-table-column>
            <el-table-column prop="wayType" label="下单方式" align="center" :formatter="formatterGame2">
            </el-table-column>
            <el-table-column prop="room" label="房间" align="center" :formatter="formatterGame">
            </el-table-column>reserve1
            <el-table-column prop="gameTime" label="密室次数" width="100">
            </el-table-column>
            <el-table-column prop="reserve1" label="游戏1" width="100">
            </el-table-column>
            <el-table-column prop="reserve2" label="游戏2" width="100">
            </el-table-column>
            <el-table-column prop="reserve3" label="游戏3" width="100">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100" :formatter="formatterstatus">
            </el-table-column>
            <el-table-column label="操作" width="250" align="center" fixed="right">
                <template #default="scope">
                    <el-button size="mini" type="primary"  @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="success"  @click="optStaut(scope.row,'1')" v-if="scope.row.status=='0'">已到店</el-button>
                    <!-- <el-button size="mini" type="warning"  @click="optStaut(scope.row,'0')" v-if="scope.row.status=='1'">未到店</el-button> -->
                    <el-popconfirm title="确定取消吗？" @confirm="optStaut(scope.row,'2')">
                        <template #reference>
                            <el-button size="mini" type="danger">取消</el-button>
                        </template>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <div style="margin: 10px 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[5, 10, 20]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="添加订单信息" v-model="dialogVisible" width="50%">
            <el-form :model="form" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="称呼">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号">
                            <el-input v-model="form.telphone"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="预订日期">
                            <el-date-picker v-model="form.orderDate" type="date" placeholder="选择日期"
                                value-format="YYYY-MM-DD" format="YYYY-MM-DD" style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="房间">
                            <el-select v-model="form.room" placeholder="请选择" style="width: 100%;" @change="getTime">
                                <el-option v-for="item in gameList" :key="item.code" :label="item.name"
                                    :value="item.code">
                                    <span style="float: left">{{ item.name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="23">
                        <div class="time-grid">
                            <div class="time-label"></div>
                            <div class="time-column" v-for="hour in gameTimeList" :key="hour">
                                <div class="hour-label">{{hour.name.substr(0,2)}}</div>
                                <div class="time-cell" v-for="quarter in quarters" :key="quarter"
                                    :class="{ 'selected': isSelected(hour, quarter) }"
                                    @click="selectTime(hour, quarter)" style="text-align: center;padding-top: 18px;">
                                    {{quarter}}</div>
                            </div>
                        </div>
                    </el-col>

                </el-row>




                <el-row>
                    <el-col :span="12">
                        <el-form-item label="开始时间">

                            <el-input v-model="form.statrTime"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="结束时间">
                            <el-input v-model="form.endTime"></el-input>
                            <!-- <el-date-picker v-model="form.endTime" type="date" placeholder="选择日期">
                            </el-date-picker> -->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人数">
                            <el-input v-model="form.perpleNum"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否开车">
                            <el-select v-model="form.bycar" placeholder="请选择" style="width: 100%;">
                                <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                    :value="item.value">
                                    <span style="float: left">{{item.label}}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="价格">
                            <el-input v-model="form.money"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="下单方式">
                            <el-select v-model="form.wayType" placeholder="请选择" style="width: 100%;">
                                <el-option v-for="item in options2" :key="item.value" :label="item.label"
                                    :value="item.value">
                                    <span style="float: left">{{item.label}}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="密室次数">
                            <el-input v-model="form.gameTime"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    </el-col>
                </el-row>



            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save">确 定</el-button>
                </span>
            </template>
        </el-dialog>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import axios from 'axios'
    export default {
        name: 'Order',
        components: {},
        data() {
            return {
                hours: Array.from({ length: 13 }, (_, i) => i + 10), // 生成10到22的数组
                quarters: ["00~15", "15-30", "30-45", "45~60"], // 时间刻度
                selectedTimes: [], // 已选择的时间
                loading: true,
                form: {},
                orderDate:"",
                room: "",
                dialogVisible: false,
                bookVis: false,
                search: '',
                currentPage: 1,
                gameList: [],
                gameTimeList: [],
                pageSize: 10,
                total: 0,
                tableData: [],
                options2: [
                    {
                        value: 0,
                        label: '点评团购'
                    }, {
                        value: 1,
                        label: '主题预订'
                    }
                ],
                options1: [{
                    value: 0,
                    label: '否'
                }, {
                    value: 1,
                    label: '是'
                }],
            }
        },
        created() {
            this.initPage()
        },
        methods: {
            getRowClassName(row) {        
                if (row.row.status =='0') {
                    return 'bg-color-1';
                } else if (row.row.status =='1') {  
                    return 'bg-color-2';
                } else if (row.row.status =='2') {
                    return 'bg-color-3';
                }
                return ''
               
            },
            formatterstatus(row, column) {
                let option = [
                    {
                        value: 0,
                        label: '待到店'
                    }, {
                        value: 1,
                        label: '已到店'
                    },
                    {
                        value: 2,
                        label: '已取消'
                    }
                ]

                var realValue = ''
                option.forEach(function (item, index) {

                    if (row.status == item.value) {
                        realValue = item.label
                        return
                    }
                })

                return realValue;

            },
            formatterGame(row, column) {
                var realValue = ''
                this.gameList.forEach(function (item, index) {

                    if (row.room == item.code) {
                        realValue = item.name
                        return
                    }
                })

                return realValue;

            },
            formatterGame1(row, column) {
                var realValue = ''
                this.options1.forEach(function (item, index) {

                    if (row.bycar == item.value) {
                        realValue = item.label
                        return
                    }
                })

                return realValue;

            },
            formatterGame2(row, column) {
                var realValue = ''
                this.options2.forEach(function (item, index) {

                    if (row.wayType == item.value) {
                        realValue = item.label
                        return
                    }
                })

                return realValue;

            },
            getTime(val) {
                request.get("/gameTime/info?code=" + val + '&curDate=' + this.form.orderDate).then(res => {
                    this.gameTimeList = res.data

                })
            },
            isSelected(hour, quarter) {
                if (hour.leaveNm == '0') {
                    return true
                } else {
                    return this.selectedTimes.includes(`${hour.name.substr(0, 2)}:${quarter.substr(0, 2)}`);
                }

            },
            selectTime(hour, quarter) {
                let len = 0
                if (hour.leaveNm == '0') {
                    return
                }
                hour = hour.name.substr(0, 2)
                const time = `${hour}:${quarter.substr(0, 2)}`;
                const index = this.selectedTimes.indexOf(time);
                if (index > -1) {
                    this.selectedTimes.splice(index, 1);
                } else {
                    this.selectedTimes.push(time);
                }
                console.log()
                len = this.selectedTimes.length
                this.selectedTimes = this.selectedTimes.sort()
                this.form.statrTime = this.selectedTimes[0]
                console.log(this.selectedTimes)
                console.log(len)
                const ent = this.selectedTimes[len - 1]

                this.form.endTime = ent.substr(0, 2) + ":" + (parseInt(ent.substr(3, 4)) + 15)

            },
            initPage() {
                axios.all([
                    // 列表初始化
                    request.get("/popular/all", {}),
                    request.get("/order", {
                        pageNum: this.currentPage,
                        pageSize: this.pageSize,
                        search: this.search,
                        room: this.room
                    }),
                ]).then(axios.spread((res1, res2,) => {
                    this.loading = false
                    this.tableData = res2.data.records
                    this.total = res2.data.total
                    this.gameList = res1.data

                }))
            },
            handleChange(row) {
                request.put("/order/changeRole", row).then(res => {
                    if (res.code === '0') {
                        this.$message.success("更新成功")
                        if (res.data) {
                            this.$router.push("/login")
                        }
                    }
                })
            },
            showBooks(books) {
                this.bookList = books
                this.bookVis = true
            },
            formatDate(row, column) {
                let data = row[column.property];
                if (data == null) {
                    return null;
                }
                let dt = new Date(data)
                return dt.getFullYear() + '年' + (dt.getMonth() + 1) + '月' + dt.getDate() + '日 ' + dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds()
            },
            load() {
                this.loading = true
                request.get("/order", {
                    params: {
                        pageNum: this.currentPage,
                        pageSize: this.pageSize,
                        search: this.search,
                        room: this.room,
                        orderDate:this.orderDate
                    }
                }).then(res => {
                    this.loading = false
                    this.tableData = res.data.records
                    this.total = res.data.total
                })

                request.get("/role/all").then(res => {
                    this.roles = res.data
                })
            },
            handleUploadSuccess(res) {
                if (res.code === "0") {
                    this.$message.success("导入成功")
                    this.load()
                }
            },
            formatterMode(row, column) {
                var realValue = ''
                this.Typeoptions.forEach(function (item, index) {

                    if (row.mode == item.remark) {
                        realValue = item.name
                        return
                    }
                })

                return realValue;

            },
            exportorder() {
                location.href = "http://" + window.server.filesUploadUrl + ":9090/order/export";
            },
            add() {
                this.$router.push("/addOrder")
            },
            save() {
                if (this.form.id) { // 更新
                    request.put("/order", this.form).then(res => {
                        console.log(res)
                        if (res.code === '0') {
                            this.$message({
                                type: "success",
                                message: "更新成功"
                            })
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            })
                        }
                        this.load() // 刷新表格的数据
                        this.dialogVisible = false // 关闭弹窗
                    })
                } else { // 新增
                    request.post("/order", this.form).then(res => {
                        console.log(res)
                        if (res.code === '0') {
                            this.$message({
                                type: "success",
                                message: "新增成功"
                            })
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            })
                        }

                        this.load() // 刷新表格的数据
                        this.dialogVisible = false // 关闭弹窗
                    })
                }

            },
            optStaut(row,status){
                row.status=status
                request.put("/order", row).then(res => {
                    debugger
                        console.log(res)
                        if (res.code === 200) {
                            this.$message({
                                type: "success",
                                message: "成功"
                            })
                            this.load()
                           
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            })
                        }


                    })

            },
            handleEdit(row) {
                this.$router.push({ path: "/addOrder", query: { id: row.id } })
            },
            handleDelete(id) {
                console.log(id)
                request.delete("/order/" + id).then(res => {
                    if (res.code === '0') {
                        this.$message({
                            type: "success",
                            message: "删除成功"
                        })
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        })
                    }
                    this.load() // 删除之后重新加载表格的数据
                })
            },
            handleSizeChange(pageSize) { // 改变当前每页的个数触发
                this.pageSize = pageSize
                this.load()
            },
            handleCurrentChange(pageNum) { // 改变当前页码触发
                this.currentPage = pageNum
                this.load()
            }
        }
    }
</script>
<style >
    .bg-color-1 {
  background-color: #cbd513 !important; /* 设置背景色为红色 */
}

.bg-color-2 {
  background-color: #0dd40d !important; /* 设置背景色为绿色 */
}

.bg-color-3 {
  background-color: #f0520f !important; /* 设置背景色为蓝色 */
}
    .time-grid {
        display: flex;
    }

    .time-label {
        width: 100px;
    }

    .time-column {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .hour-label {
        margin-bottom: 10px;
    }

    .time-cell {
        width: 50px;
        height: 50px;
        border: 1px solid #ccc;
        margin-bottom: 5px;
        cursor: pointer;
    }

    .selected {
        background-color: red;
        color: white;
    }
</style>